import { render } from "./ClientSpacePurchase.vue?vue&type=template&id=dcb5984a&scoped=true"
import script from "./ClientSpacePurchase.vue?vue&type=script&lang=js"
export * from "./ClientSpacePurchase.vue?vue&type=script&lang=js"

import "./custom-clientSpace.scss?vue&type=style&index=0&id=dcb5984a&lang=scss&scoped=true"
import "./custom-clientSpacePurchase.scss?vue&type=style&index=1&id=dcb5984a&lang=scss&scoped=true"
import "./ClientSpacePurchase.vue?vue&type=style&index=2&id=dcb5984a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcb5984a"]])

export default __exports__